module.exports = __webpack_public_path__ + "static/8-47e78319ce34fa8392147ff495f9f4cf.png";